export const DISPLAY_CONSTANTS = {
  APP_NAME: $localize`GSL: Global Scan and Link`,
  APP_NAME_SMALL: $localize`GSL`,
  APP_NAME_SCI: $localize`SCI: Scanning Customer Integration`,
  APP_NAME_SCI_SMALL: $localize`SCI`,
  PROFILE_USER_NAME: {
    PROFILE: $localize`My Profile`,
    NOTIFICATIONS: $localize`Notifications`,
  },
  SEARCH_BAR_PLACEHOLDER: $localize`Search Tracking Number`,
  LOADING_TEXT: $localize`Loading...`,
  GROUP_TEXT: $localize`Group`,
  LOCATION_TEXT: $localize`Location`,
  SEARCH: $localize`Search`,
};
